import _lib from '../_lib';
import active from './active/index';
import {CptBillingNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'cptbilling';
  let activations = [
    {
      name: 'cptbilling',
      test: api.messageIs(CptBillingNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};